import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { EditorsPostProps } from '@/components/(blog)/post/PostEditorsChoice';
import ArrowLeftSLineIcon from 'remixicon-react/ArrowLeftSLineIcon';
import { safeHtmlLinks } from '@/utils/links/safeHref';

export const PostCardWithExcerpt: React.FC<EditorsPostProps> = ({
    slug,
    title,
    featuredImage,
    aside,
    excerpt,
}) => {
    return (
        <Link
            href={slug}
            rel='noopener noreferrer'
            className={`h-full flex lg:flex-col relative gap-2 overflow-hidden transition-all hover:bg-primary/10 dark:hover:bg-white/10 group'}`}
        >
            {featuredImage && (
                <Image
                    src={featuredImage.node.sourceUrl || ''}
                    width={1300}
                    height={400}
                    title={
                        featuredImage.node.title
                            ? featuredImage.node.title
                            : title || 'related_image_alt'
                    }
                    alt={
                        featuredImage.node.altText
                            ? featuredImage.node.altText
                            : title || 'related_image_alt'
                    }
                    className={`w-1/3 lg:w-full aspect-video object-cover`}
                />
            )}
            <div className={'flex flex-col gap-2 p-2 lg:p-3 lg:pt-5'}>
                <p
                    className={`w-full text-xs max-lg:line-clamp-1 lg:text-base leading-5 font-light text-wrap`}
                >
                    {title}
                </p>
                {excerpt && (
                    <div
                        className='text-[10px] lg:text-xs pe-3 text-gray-400 line-clamp-2 lg:line-clamp-3 leading-[1.8] [&>p]:m-0'
                        dangerouslySetInnerHTML={{ __html: safeHtmlLinks(excerpt || '') }}
                    />
                )}
                <div
                    className={
                        'flex items-end justify-center text-center text-white text-xs absolute left-0 bottom-0'
                    }
                >
                    <ArrowLeftSLineIcon
                        size={22}
                        className={`${aside && 'hidden'} dark:bg-progress bg-progress/90 rounded-tr-lg group-hover:brightness-125 transition-all duration-200`}
                    />
                </div>
            </div>
        </Link>
    );
};
